/* Élan Vivre — small UX upgrades: FAQ accordion + search. */
(function () {
  function faq() {
    if (!/\/pages\/faq/.test(location.pathname)) return;
    var rte = document.querySelector('.main-page-title ~ .rte');
    if (!rte || rte.querySelector('details.ev-faq')) return;
    var qs = [].slice.call(rte.querySelectorAll('h3'));
    if (!qs.length) return;
    qs.forEach(function (h) {
      var d = document.createElement('details');
      d.className = 'ev-faq';
      var s = document.createElement('summary');
      s.textContent = h.textContent;
      var a = document.createElement('div');
      a.className = 'ev-faq__a';
      var n = h.nextElementSibling;
      while (n && !/^H[1-3]$/.test(n.tagName)) { var next = n.nextElementSibling; a.appendChild(n); n = next; }
      d.appendChild(s); d.appendChild(a);
      h.parentNode.replaceChild(d, h);
    });
    [].slice.call(rte.querySelectorAll('h2')).forEach(function (h) { h.classList.add('ev-faq-group'); });
    var wrap = document.createElement('label');
    wrap.className = 'ev-faq-search';
    wrap.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg><span class="visually-hidden">Search questions</span><input type="search" placeholder="Search questions — e.g. sunscreen, shipping, retinol">';
    var empty = document.createElement('p');
    empty.className = 'ev-faq-empty';
    empty.textContent = 'No matching questions. Try another word, or get in touch below.';
    rte.parentNode.insertBefore(wrap, rte);
    rte.appendChild(empty);
    var input = wrap.querySelector('input');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), shown = 0;
      [].slice.call(rte.querySelectorAll('details.ev-faq')).forEach(function (d) {
        var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.style.display = hit ? '' : 'none';
        if (hit) shown++;
        if (q && hit) d.open = true; else if (!q) d.open = false;
      });
      [].slice.call(rte.querySelectorAll('.ev-faq-group')).forEach(function (g) {
        var n = g.nextElementSibling, any = false;
        while (n && !n.classList.contains('ev-faq-group')) { if (n.matches('details.ev-faq') && n.style.display !== 'none') any = true; n = n.nextElementSibling; }
        g.style.display = any ? '' : 'none';
      });
      empty.style.display = shown ? 'none' : 'block';
    });
    var c = document.createElement('div');
    c.className = 'ev-faq-contact';
    c.innerHTML = '<h3>Still have a question?</h3><p>Our team is happy to help you choose the right ritual.</p><a href="/pages/contact">Get in touch</a>';
    rte.appendChild(c);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', faq); else faq();
})();
